import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { shellStringResources } from 'shell-models-lib';
import { partitionOptionConst, partitionOptionForwardLinkMap, queryTimeoutMetadata, sqlAnalyticsEndpointPartitionOptions } from '../consts/metadata-consts';
import { ColumnPhysicalType, ColumnType, defaultSupportedColumnTypes, sqlBinaryPhysicalTypes } from 'app/shared/utils/column-type.util';

export const sqlAnalyticsEndpointDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sqlAnalyticsEndpoint.datasetType,
    displayName: shellStringResources.SqlAnalyticsEndpoint_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.sqlAnalyticsEndpoint.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i_dataWarehouse'
    },
    isFirstClass: true,
    disableTableName: true,
    supportDataFlowSink: false,
    supportDataFlowSource: false,
    category: ['Workspace'],
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    supportEditPhysicalType: __IS_FABRIC_DPE__,
    copySourceControls: [
        queryTimeoutMetadata,
        {
            type: 'radio-switch',
            label: stringResources.ModelName_Partition_Option,
            defaultValue: partitionOptionConst.none,
            description:
                '<a target="_blank" href="' +
                partitionOptionForwardLinkMap[adfModelTypeMap.sqlAnalyticsEndpoint.copySourceType] +
                '">' +
                stringResources.LearnMore +
                '</a>',
            escapeDescription: false,
            options: sqlAnalyticsEndpointPartitionOptions,
            bind: 'partitionOption',
            isParameterizable: true,
            cases: [
                {
                    caseValue: partitionOptionConst.dyamicRange,
                    children: [
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'columns-selection',
                                bind: 'partitionColumnName',
                                label: stringResources.ModelName_Partition_ColumnName,
                                multiple: false,
                                includeCopySourceProperties: true,
                                allowedColumnTypes: ['Int16', 'Int32', 'Int64', 'DateTime', 'TimeSpan'],
                                excludeSourceProperties: ['partitionOption', 'partitionSettings']
                            },
                            dynamicContentTextClass: 'input-spaced'
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'partitionUpperBound',
                                label: stringResources.ModelName_Partition_UpperBound
                            },
                            dynamicContentTextClass: 'input-spaced'
                        },
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'textbox',
                                bind: 'partitionLowerBound',
                                label: stringResources.ModelName_Partition_LowerBound
                            },
                            dynamicContentTextClass: 'input-spaced'
                        }
                    ]
                }
            ]
        }
    ],
    LogicalToPhysicalMapping: {
        int16: ColumnPhysicalType.Smallint,
        int32: ColumnPhysicalType.Int,
        int64: ColumnPhysicalType.Bigint,
        byte: ColumnPhysicalType.Int,
        'byte[]': ColumnPhysicalType.Varbinary,
        // eslint-disable-next-line id-blacklist
        boolean: ColumnPhysicalType.Bit,
        // eslint-disable-next-line id-blacklist
        string: ColumnPhysicalType.Varchar,
        date: ColumnPhysicalType.Date,
        datetime: ColumnPhysicalType.Datetime2,
        datetimeoffset: ColumnPhysicalType.Varchar,
        decimal: ColumnPhysicalType.Decimal,
        'char[]': ColumnPhysicalType.Varchar,
        single: ColumnPhysicalType.Real,
        timespan: ColumnPhysicalType.Time,
        guid: ColumnPhysicalType.Uniqueidentifier,
        double: ColumnPhysicalType.Float,
        xml: ColumnPhysicalType.Varchar,
        sbyte: ColumnPhysicalType.Smallint,
        uint16: ColumnPhysicalType.Int,
        uint32: ColumnPhysicalType.Bigint,
        uint64: ColumnPhysicalType.Bigint
    },
    PhysicalToLogicalMapping: {
        bit: ColumnType.Boolean,
        smallint: ColumnType.Int16,
        int: ColumnType.Int32,
        bigint: ColumnType.Int64,
        date: ColumnType.DateTime,
        datetime2: ColumnType.DateTime,
        time: ColumnType.TimeSpan,
        decimal: ColumnType.Decimal,
        numeric: ColumnType.Decimal,
        float: ColumnType.Double,
        real: ColumnType.Single,
        uniqueidentifier: ColumnType.Guid,
        varbinary: ColumnType.ByteArray,
        char: ColumnType.String,
        varchar: ColumnType.String
    },
    supportedPhysicalTypes: [
        ColumnPhysicalType.Bit,
        ColumnPhysicalType.Smallint,
        ColumnPhysicalType.Int,
        ColumnPhysicalType.Bigint,
        ColumnPhysicalType.Date,
        ColumnPhysicalType.Datetime2,
        ColumnPhysicalType.Time,
        ColumnPhysicalType.Decimal,
        ColumnPhysicalType.Numeric,
        ColumnPhysicalType.Float,
        ColumnPhysicalType.Real,
        ColumnPhysicalType.Uniqueidentifier,
        ColumnPhysicalType.Varbinary,
        ColumnPhysicalType.Char,
        ColumnPhysicalType.Varchar
    ],
    binaryPhysicalTypes: sqlBinaryPhysicalTypes,
    binaryLengthMap: {
        varbinary: {
            minValue: 1,
            maxValue: 8000,
            supportMaxValue: __IS_FABRIC_DPE__,
            defaultValue: 8000
        },
        char: {
            minValue: 1,
            maxValue: 8000,
            supportMaxValue: false
        },
        varchar: {
            minValue: 1,
            maxValue: 8000,
            supportMaxValue: __IS_FABRIC_DPE__,
            defaultValue: 8000
        }
    },
    precisionMap: {
        datetime2: {
            minValue: 0,
            maxValue: 6
        },
        decimal: {
            minValue: 1,
            maxValue: 38
        },
        numeric: {
            minValue: 1,
            maxValue: 38
        }
    },
    scaleMap: {
        time: {
            minValue: 0,
            maxValue: 6
        },
        decimal: {
            minValue: 0,
            maxValue: 38,
            defaultValue: 18,
            smallerThanPrecision: true
        },
        numeric: {
            minValue: 0,
            maxValue: 38,
            defaultValue: 18,
            smallerThanPrecision: true
        }
    }
};
